<template>
  <v-container class="container">
    <!--    <div align="center" v-if="expires_in!=-1" style="background-color: #f3aa32">-->
    <!--      <h4>Tiempo actualización en: {{ this.expires_in }}</h4>-->
    <!--    </div>-->
    <v-form ref="form" v-model="valid" lazy-validation>
        <div style="display: flex; align-items: center; padding-block-start: 50px;">
          <div icon @click="setNormalView" class="box">
            <img src="https://dunedingoescarting.com/wp-content/uploads/2019/09/map-1272165_960_720.png" width="40px" class="icon"/>
          </div>
          <div icon @click="setTrafficView" class="box">
            <img src="https://e7.pngegg.com/pngimages/520/93/png-clipart-computer-icons-traffic-light-symbol-traffic-light-driving-traffic-sign.png" width="40px" class="icon"/>
          </div>
          <div align="center" v-if="expires_in!=-1">
            <h4>Tiempo actualización en: {{ this.expires_in }}</h4>
          </div>
        </div>
     
      <GmapMap ref="gmap" :center="this.mapView" :zoom="7" map-type-id="roadmap"  style="height: 90vh; padding-top:70px">
        <GmapMarker :id="m.imei" :key="'marker-' + m.imei" v-for="(m, index) in markers" @click="selectMarker(m)"
          :position="m.position" :clickable="true" :icon="m.icon" />

        <gmap-info-window :id="'info-' + m.imei + '-' + m.idTraccar" :key="'info-' + m.imei + '-' + m.idTraccar"
          v-for="(m, index) in markers" :position="m.position" :options="{
      pixelOffset: {
        width: 0,
        height: -50
      },
      disableAutoPan: true
    }">
          <p>{{ m.name }}</p>
        </gmap-info-window>
      </GmapMap>

      
    </v-form>
  </v-container>
</template>
<script>
import VueTimepicker from 'vue2-timepicker/src'
import $ from 'jquery';

export default {
  props: [
    'devices',
    'device',
  ],
  components: {
    VueTimepicker
  },
  data() {
    return {
      search: '',
      valid: false,
      markers: [],
      newMarkers: [],
      deviceObject: {id: "", value: "", date: new Date()},
      marker: null,
      mapView: {lat: -1.24908, lng: -78.61675},
      expires_in: 0,
      selectedInMap: "",
      dialogReport: false,
      searched: false,
      reportType: '',
      directionDevice: 0,
      imageDevice: "",
      selectedImei: "",
    };
  },
  watch: {},
  methods: {
    createInterval() {
      clearInterval(this.$store.state.intervalMapDevice)
      clearInterval(this.$store.state.intervalMap)
      this.$store.state.intervalMap = setInterval(() => {
        if (this.expires_in === 0) {
          this.expires_in = 10;
          this.markers = [];
          this.newMarkers =[];
          for (let i = this.devices.length; i > 0; i--) {
            this.selectedItemMap(this.devices[i - 1], i-1);
          }
          this.markers=this.newMarkers
        } else {
          this.expires_in = this.expires_in - 1;
        }
      }, 1000);
    },
    
    selectMarker(item) {
      this.selectedImei = item.imei
      this.updateDevice(item)
      this.$emit('close-dialog', this.device)
    },
    selectedItemMap(itemDevice, index) {
      if(!itemDevice.idTraccar){
        return
      }
      if(!this.$store.getters.isActiveDevice(itemDevice)){
        return
      }
      this.$store.dispatch('getDevicesLocationTraccar', itemDevice.idTraccar).then(response => {
        if (response.data.result.length == 0) {
          this.dialogError = true
        } else {
   
          let queryParam = "deviceId="+itemDevice.idTraccar+"&from="+this.dateStart()+"&"+"to="+this.dateEnd()
          let timeStop = 0;
          let offline = false;

          // Get the latest events
          this.$store.dispatch('getDevicesLocationTraccarAlarm', queryParam).then(responseEvent => {
            this.directionDevice = response.data.result[0].direction
            let image = itemDevice.image
            let motion = response.data.result[0].motion;
            let accStatus = response.data.result[0].accStatus;
            if (response.data.result[0].status === 'rely' || (accStatus == '1' && motion == '0')) {
              image = image.replace("1.", "A.");
            } else if (accStatus == '1' && parseInt(response.data.result[0].speed) > 0) {
              image = image.replace("1.", "V.");
            } else if (accStatus == '0') {
              image = image.replace("1.", "R.");
            } else {
              image = image.replace("1.", "G.");
            }

            image = image.replace("nuevos/", index+"/nuevos/");  

            let now = new Date();
            let deviceTime = new Date(response.data.result[0].deviceTime);
            let minutesForOffline = 10 * 60 * 1000; // 10 minutes
            // If the latest position device time is grater than minutesForOffline then
            // assing time between deviceTime and now to timeStop
            if (now - deviceTime > minutesForOffline) {
              image = image.replace("1.", "G.");
              image = image.replace("V.", "G.");
              image = image.replace("R.", "G.");
              image = image.replace("A.", "G.");
              timeStop = (deviceTime.getTime() - (now.getTime())) * -1;
              offline = true;
            } else {
              offline = false
            }

            // If device is stopped then get timeStop from event response when type is ignitionOff
            if (!offline && accStatus == '0') {
              for (let i = 0; i < responseEvent.data.length; i++) {
                if (responseEvent.data[i].type == "ignitionOff") {
                  deviceTime = new Date(responseEvent.data[i].eventTime);
                  timeStop = (now.getTime() - deviceTime.getTime());
                  break;
                }
              }
            }

            let respPosition = {
              position: {
                lat: response.data.result[0].lat,
                lng: response.data.result[0].lng,
                imei: itemDevice.imei
              },
              icon: {
                url2: image,
                url: image,
                scaledSize: {width: 55, height: 55, f: 'px', b: 'px'},
                rotation: 120,
              },
              deviceId: itemDevice.idTraccar,
              imei: itemDevice.imei,
              name: itemDevice.name,
              sim: itemDevice.sim,
              model: itemDevice.model,
              image: image,
              directionDevice: response.data.result[0].direction,
              accStatus: accStatus,
              speed: response.data.result[0].speed,
              blocked: itemDevice.lastAction == 'Bloquear' ? true : false,
              offline: offline,
              timeStop: timeStop,
              odometer: response.data.result[0].odometer,
              sat:response.data.result[0].attributes.sat,
            }
              //this.mapView = {lat: -0.190029, lng: -78.482114},
           
              //this.markers = []
              this.newMarkers.push(respPosition)
              if(this.selectedImei === respPosition.imei){
                this.updateDevice(respPosition)
              }
        
          })
        }
      })
    },
    updateDevice(marker) {
      this.device.odometer = marker.odometer
      this.device.idTraccar = marker.deviceId
      this.device.odometer = marker.odometer
      this.device.accStatus = marker.accStatus
      this.device.speed = marker.speed
      this.device.offline = marker.offline
      this.device.timeStop = marker.timeStop
      this.device.imei = marker.imei
      this.device.name = marker.name
      this.device.sim = marker.sim
      this.device.model = marker.model
      this.device.image = marker.image
      this.device.direction = marker.directionDevice
    },
    dateStart(){
      let date = new Date();
      // Five days ago
      date.setTime(date.getTime() - (5 * 24 * 60 * 60 * 1000)); // Convert hours to milliseconds - 60 minutes to an hour, 60 seconds to a minute, 1000 milliseconds to a second

      var day = date.getDate() + "";
      var month = date.getMonth()+1 + "";
      var year = date.getFullYear() + "";
      var hour = date.getHours()+"";
      var minutes = date.getMinutes() + "";
      var seconds = date.getSeconds() + "";


      day = this.checkZero(day);
      month = this.checkZero(month);
      year = this.checkZero(year);
      hour = this.checkZero(hour);
      minutes = this.checkZero(minutes);
      seconds = this.checkZero(seconds);

      return year + "-" + month + "-" + day + "T" + hour + ":" + minutes + ":" + seconds+"-05";
    },
    dateEnd(){
      let date = new Date();
      var day = date.getDate() + "";
      var month = date.getMonth()+1 + "";
      var year = date.getFullYear() + "";
      var hour = date.getHours() + "";
      var minutes = date.getMinutes() + "";
      var seconds = date.getSeconds() + "";

      day = this.checkZero(day);
      month = this.checkZero(month);
      year = this.checkZero(year);
      hour = this.checkZero(hour);
      minutes = this.checkZero(minutes);
      seconds = this.checkZero(seconds);

      return year + "-" + month + "-" + day + "T" + hour + ":" + minutes + ":" + seconds+"-05";
    },
    checkZero(data){
      if(data.toLocaleString().length == 1){
        data = "0" + data;
      }
      return data;
    },
    initializeMap() {
      this.$refs.gmap.$mapPromise.then(map => {
        this.trafficLayer = new google.maps.TrafficLayer();
        this.updateMapView(); // Ensure the map starts with the correct view
      });
    },
    setNormalView() {
      this.isTrafficView = false;
      this.updateMapView();
    },
    setTrafficView() {
      this.isTrafficView = true;
      this.updateMapView();
    },
    updateMapView() {
      this.$refs.gmap.$mapPromise.then(map => {
        if (this.isTrafficView) {
          this.trafficLayer.setMap(map);
        } else {
          this.trafficLayer.setMap(null);
        }
      });
    },
  },
  mounted() {
    this.initializeMap();
  },
  computed: {},
  created() {
    clearInterval(this.$store.state.intervalMap)
    this.createInterval()
    clearInterval(this.$store.state.intervalMapDevice)
    this.$store.state.intervalMapDevice = setInterval(() => {
      if(this.markers.length>0){
        for (const marker of this.markers) {
          const $element = $('img[src*="' + marker.image + '"]').parent();
            $element.hide(); // Hide the element
            $element.css('transform', 'rotate(' + marker.directionDevice + 'deg)'); // Rotate the element
            $element.show(); // Show the element again
        }
      }
    }, 1000);
  },
};
</script>

<style>
.container {
  max-width: 100% !important;
  padding: 0%;
}
td
{
  height: 50px;
  width: 50px;
}

#cssTable td
{
  text-align: center;
  vertical-align: middle;
}

  .containerdiv {
    display: flex;
  }
  .image-container {
    padding-top: 4px;
    padding-left: 30px;
    width: 50%;
    height: 50px;
  }
  .details-container {
    margin-top: 20px;
    margin-left: 20px;
    text-align: left;
    width: 50%;
  }
  p {
    margin-bottom: 0 !important;
  }
  .box {
    width: 25px;
    height: 25px;
    padding-inline-end: 50px;
  }

</style>



// WEBPACK FOOTER //
// src/components/device/mobile/MapMobileMultiple.vue